import { fetchBranding } from './api/branding-client-api';
import type { BrandingClientSetResponse } from './types';

export async function getBrandingByName(
  name: string
): Promise<BrandingClientSetResponse> {
  return fetchBranding({
    urlPrefix: name,
    allowDisabled: true,
  });
}

/**
 * Fetches branding by customer token. When `urlPrefix` is set (branded subdomain),
 * it is included so the API can prefer the host brand over a token-only default set.
 */
export async function getBrandingByToken(
  token: string,
  urlPrefix?: string | null
): Promise<BrandingClientSetResponse> {
  if (urlPrefix) {
    return fetchBranding({
      customerToken: token,
      urlPrefix,
    });
  }
  return fetchBranding({ customerToken: token });
}
